module.exports = __webpack_public_path__ + "static/img/AUG.98e70fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/AUG.png
// module id = Vkd7
// module chunks = 0